import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import Isvg from 'react-inlinesvg';

import logo from '../assets/svg/logo.svg';

import social1 from '../assets/svg/social1.svg';
import social2 from '../assets/svg/social2.svg';
import social3 from '../assets/svg/social3.svg';


import instagramLogo from '../assets/svg/instagram-logo.svg';
import image1 from '../assets/images/insta1.png';
import image2 from '../assets/images/insta2.png';
import image3 from '../assets/images/insta3.png';
import image4 from '../assets/images/insta4.png';
import image5 from '../assets/images/insta5.png';
import image6 from '../assets/images/insta6.png';


import newsletterIcon from '../assets/svg/newsletter-icon.svg';
import phoneIcon from '../assets/svg/phone.svg';
import mailIcon from '../assets/svg/email.svg';


import {
    Container,
    Row,
    Col,
} from 'reactstrap';

class Footer extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }



    componentDidMount() {
        if (this.props.socketIOClient) {
            this.registerSocketIOEvents();
        }

    }

    componentDidUpdate(prevProps) {
        if (this.props.socketIOClient) {
            this.registerSocketIOEvents();
        }

    }

    registerSocketIOEvents = () => {
        if (this.state._registeredEvents)
            return;

        this.setState({
            _registeredEvents: true
        });

        this.props.socketIOClient.on('subscribeToNewsletter', (data) => {
            console.log(data);
            this.setState({
                _done: true,
                email: ''
            })
        });



    }

    componentWillUnmount() {
        if (!this.props.socketIOClient) return;
        this.props.socketIOClient.removeAllListeners("subscribeToNewsletter");
        //this.props.socketIOClient.removeAllListeners("fetchProductVariations");

    }


    subscribe = () => {

        this.props.socketIOClient.emit("subscribeToNewsletter", { email: this.state.email });
    }
    render() {

        return (
            <>

                <section className="section-instagram">
                    <Container>
                        <Row>
                            <Col lg="12" className="title">
                                <h3><span>PRATITE NAS </span> NA INSTAGRAMU</h3>
                                <h6><a href="https://www.instagram.com/marvogroup/" target="_blank"> <Isvg src={instagramLogo} /> marvogroup  </a> </h6>
                            </Col>
                        </Row>

                        <Row>
                            {
                                this.props.instagramPhotos.map((item, idx) => {
                                    return (
                                        <Col lg="2" xs="6" className="image">
                                            <a href={item.link} target="_blank">
                                                <img src={item.preview} />
                                            </a>
                                        </Col>

                                    )
                                })
                            }
                        </Row>



                    </Container>
                </section>
                <section className="section-newsletter">

                    <Container>
                        <Row>
                            <Col lg="12" className="content">
                                <Isvg src={newsletterIcon} />

                                <Row>
                                    <Col lg="6">
                                        <h3><span>PRIJAVITE SE</span> NA<br />NAŠ NEWSLETTER</h3>
                                    </Col>
                                    <Col lg="6">
                                        {this.state._done ?
                                            <p className="done">Uspješno ste se prijavili na naš newsletter</p>
                                            :
                                            <div className="input">
                                                <input type="text" value={this.state.email} onChange={(e) => this.setState({ email: e.target.value })} placeholder="Unesite svoju e-mail adresu" />
                                                <button onClick={this.subscribe}>PRIJAVI SE</button>
                                            </div>
                                        }
                                        {
                                            this.state._error ?
                                                <p className="err">Greška!</p>
                                                :
                                                null
                                        }
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>

                </section>

                <footer>
                    <Container>
                        <Row>
                            <Col lg="3" className="logo">
                                <Isvg src={logo} />
                                <p>Born for gaming

</p>
                            </Col>
                            <Col lg={{ size: 4, offset: 1 }}>
                                <h6>NAVIGACIJA</h6>
                                <ul>
                                    <li><Link to='/'>Početna</Link></li>
                                    <li><Link to='/category?display=promoted'>Izdvojeno</Link></li>
                                    <li><Link to='/category'>Proizvodi</Link></li>
                                    <li><Link to='/novosti'>Novosti</Link></li>
                                    <li><Link to='/category?display=offer'>Na akciji</Link></li>
                                    <li><Link to='/contact'>Kontakt</Link></li>
                                    <li><Link to='/page/terms-and-conditions'>Uslovi korštenja</Link></li>
                                    <li><Link to='/page/privacy-policy'>Politika privatnosti</Link></li>

                                </ul>
                            </Col>
                            <Col lg="2">
                                <div className="contact-item">
                                    <p><Isvg src={phoneIcon} /> POZOVITE NAS</p>
                                    <a href="tel:0038755226920"><h6> +387 63 523 523
</h6></a>
                                </div>
                                <div className="contact-item">
                                    <p><Isvg src={mailIcon} /> POŠALJITE UPIT</p>
                                    <a href="mailto:info@marvo.ba"><h6>info@marvo.ba</h6></a>
                                </div>

                            </Col>
                            <Col lg="2" className="social">
                                <div>
                                    <a href="https://www.facebook.com/" target="_blank"><Isvg src={social1} /></a>
                                    <a href="https://www.instagram.com/" target="_blank"><Isvg src={social2} /></a>
                                    <a href="#" target="_blank"><Isvg src={social3} /></a>
                                </div>
                            </Col>

                            <Col lg="12">
                                <div className="spacer"></div>
                            </Col>

                            <Col lg="6">
                                <p className="copyright1">Copyright © MARVO.ba  - 2020. All Rights Reserved.</p>
                            </Col>
                            <Col lg="6">
                                <p className="copyright2">Created by <a href="https://novamedia.agency" target="_blank">nova media.</a></p>
                            </Col>

                        </Row>
                    </Container>

                    {/* <button className="scroll-up" onClick={() => {
                        if (typeof window !== 'undefined') { window.scrollTo({ behavior: 'smooth', top: 0 }); }

                    }}></button>
                */}
                </footer>
            </>
        );
    }
}

export default Footer;